import { render, staticRenderFns } from "./tell.vue?vue&type=template&id=3ddb55b0&scoped=true"
import script from "./tell.vue?vue&type=script&lang=js"
export * from "./tell.vue?vue&type=script&lang=js"
import style0 from "./tell.vue?vue&type=style&index=0&id=3ddb55b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb55b0",
  null
  
)

export default component.exports